<!--
	<Confirm ref="confirm" @confirm="fn"></Confirm>
 -->
<template>
	<Window :title="myTitle || title" :btnClose="cancelBtn" :size="option.size" @Close="hide(false)" @Closed="onClosed" ref="Window" :btnCancel="false">
		<span v-html="myText"></span>
		<!-- <slot></slot> -->
		<button slot="btmBtn" class="subBtn" @click="hide" v-show="cancelBtn" type="button">{{ cancelText }}</button>
		<button slot="btmBtn" class="functionBtn" type="button" @click="confirm">{{ okBtnText }}</button>
	</Window>
</template>
<script>
import * as lib from "@/util/lib.js";
import { getLanguageStr } from "@/util/language.js";

import Window from "@/components/common/ui/WindowForAlert.vue";

export default {
	name: "confirm",
	components: { Window },
	props: {
		title: {
			type: String,
			default: getLanguageStr("plant_detail77", "请确认"),
		},
		text: {
			type: String,
			default: "",
		},
		cancelText: {
			type: String,
			default: getLanguageStr("cmd85", "取消"),
		},
		okBtnText: {
			type: String,
			default: getLanguageStr("cmd12", "确定"),
		},
		cancelBtn: {
			type: Boolean,
			default: true,
		},
		size: {
			type: String,
			default: "xs",
		},
	},
	data() {
		return {
			dynamic: null,
			option: {
				size: this.size,
			},
			myTitle: this.title,
			myText: this.text,
			obj: {},
		};
	},
	// watch:{
	// 	myText:function(val){
	// 		trace(this.obj)
	// 	}
	// },
	methods: {
		getLanguageStr,
		show: function (option, dynamic) {
			if (dynamic) this.dynamic = dynamic;
			// {
			// 	title:"",
			// 	text:"",
			// 	yes:function,
			// 	no:function
			// }
			this.myTitle = this.title;
			this.myText = this.text;
			this.obj = option || {};
			// $.extend(true,this.obj,option);
			if (option) {
				if (option.size) this.option.size = option.size;
				//支持动态改变大小
				else this.option.size = this.size;
				if (option.title) this.myTitle = option.title;
				if (option.text) {
					this.$set(this, "myText", option.text);
					// trace(this.myText)
				}
			}
			this.$nextTick(() => {
				this.$refs.Window.show();
			});
		},
		hide: function (action = true) {
			if (this.obj.no) {
				this.obj.no();
			}
			if (action) {
				//透传出来的事件本身已经是hide
				this.$refs.Window.hide();
			}
			this.$emit("cancel", this.obj);
		},
		onClosed: function () {
			if (this.dynamic) this.dynamic.destroyUi();
		},
		confirm() {
			if (this.obj.yes) {
				this.obj.yes(this.obj);
			} else this.$emit("confirm", this.obj);
			this.hide();
		},
	},
	mounted() {},
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/common/ui/Confirm.vue